import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Icon } from '@syneto/compass-react';
import { navigateToMenuItem } from '../../data/actions/navigation';
import MenuItem from './components/MenuItem';
import SidebarFooter from './components/SidebarFooter';


const Sidebar = (props) => {
	const { activeMenu, userName, userRole, sections, navigateToMenuItem } = props;
	const sectionsRef = useRef(null);
	const [hasMoreBelow, setHasMoreBelow] = useState(false);

	useEffect(() => {
		const element = sectionsRef.current;
		const updateHasMoreBelow = () => {
			setHasMoreBelow(element.scrollHeight - element.scrollTop - element.clientHeight > 1);
		};
		const resizeObserver = new ResizeObserver(updateHasMoreBelow);

		resizeObserver.observe(element);
		element.addEventListener('scroll', updateHasMoreBelow);

		return () => {
			resizeObserver.disconnect();
			element.removeEventListener('scroll', updateHasMoreBelow);
		};
	}, []);

	return (
		<nav className={`sidebar ${hasMoreBelow ? 'sidebar--has-more-below' : ''}`}>
			<div className="sidebar-sections" ref={sectionsRef}>
				{
					sections.map((section) => {
						return (
							<div key={section.LABEL} className="sidebar-section">
								<div className="sidebar-section-title">
									<Icon name={`far ${section.ICON} fa-fw`} className="sidebar-section-icon" />
									{section.LABEL}
								</div>

								<ul className="sidebar-section-items">
									{
										section.ITEMS.map((item) => {
											return <MenuItem key={item.IDENTIFIER} item={item} sectionLabel={section.LABEL} activeMenu={activeMenu} navigateToMenuItem={navigateToMenuItem} />;
										})
									}
								</ul>
							</div>
						);
					})
				}
			</div>

			<SidebarFooter userName={userName} userRole={userRole} />
		</nav>
	);
};

const mapStateToProps = ({ sidebar, user }) => {
	return {
		activeMenu: sidebar.activeMenu,
		userName: [user?.user?.contact?.firstName, user?.user?.contact?.lastName].filter(Boolean).join(' '),
		userRole: user?.user?.account?.role
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		navigateToMenuItem: (menuProperties) => {
			return dispatch(navigateToMenuItem(menuProperties));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
